export enum DisplayType{
    DESKTOP = "desktop",
    MOBILE = "mobile"
}
